function bandFor(value: number): { label: string; className: string } {
  if (value < 40) return { label: 'Low', className: 'bg-status-open' }
  if (value <= 70) return { label: 'Medium', className: 'bg-status-pending' }
  return { label: 'High', className: 'bg-status-resolved' }
}

export function ConfidenceMeter({ value }: { value: number }) {
  const { label, className } = bandFor(value)
  return (
    <div className="space-y-1">
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
        <div className={`h-full rounded-full ${className}`} style={{ width: `${value}%` }} />
      </div>
      <p className="text-xs text-muted-foreground">
        Confidence: {value}% ({label}) — advisory, verify before acting
      </p>
    </div>
  )
}
